import { RootState } from "@/app/stores";
import { createSelector } from "@reduxjs/toolkit";

const baseSelector = createSelector(
    (state: RootState) => state,
    state => state.userBroadcast
)

export const selectIsUserBroadcastModalOpen = createSelector(
    baseSelector,
    (state) => state.isUserBroadcastModalOpen
)

export const selectOnSuccess = createSelector(
    baseSelector,
    (state) => state.onSuccess
)

export const selectCurrentUser = createSelector(
    baseSelector,
    (state) => state.currentUser
)

